import React from "react";
import { Stack, Container, Typography } from "@mui/material";
import { Link } from "@mui/material";
import { config } from "../../config";

export default function Footer() {
  return (
    <div
      style={{
        background: config.colors.primary,
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          pt: 4,
          pb: 4,
        }}
      >
        <Stack alignItems={"center"}>
          <Typography color={config.colors.white}>Powered by</Typography>
          <Link href="https://sabinaai.com">
            <img
              src="/assets/sabinaai-white.png"
              style={{ maxWidth: "200px", marginTop: "20px" }}
            />
          </Link>
        </Stack>
      </Stack>
    </div>
  );
}
